import { useApolloClient } from '@apollo/client';
import { Cache } from 'aws-amplify/utils';
import { signOut } from 'aws-amplify/auth';
import {
  isLoggedInVar,
  recentClientsInVar,
  selectedEntityIdInVar,
} from '@admiin-com/ds-graphql';
import { useModal } from '../../components/ModalManager/ModalContext';
import { clearCachedUser } from '../../../hooks/useCurrentUser/useCurrentUser';

export const useLogout = () => {
  const client = useApolloClient();
  const { closeAllModals } = useModal();
  const logout = async () => {
    client.cache.evict({ fieldName: 'me' });
    client.cache.gc();

    try {
      closeAllModals();
      isLoggedInVar(false);
      selectedEntityIdInVar(null);
      recentClientsInVar([]);
      clearCachedUser();
      localStorage.clear();
      await Cache.clear();
      await signOut();
      window.location.href = '/sign-in';
    } catch (err) {
      console.log('ERROR log out: ', err);
    }
  };
  return logout;
};
